"use client"

import React from "react"
import type { UseFormReturn } from "react-hook-form"
import { FormField, FormItem, FormControl, FormMessage, Input, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Textarea } from "@/components/ui/components"

export default function ReturnFields(props: {
  form: UseFormReturn<any>
  t: (k: string) => string
  show: (k: string) => boolean
  // required flags
  reqRetArticle: boolean
  reqRetQuantity: boolean
  reqRetReason: boolean
  reqRetMessage: boolean
  // labels
  returnLabel: string
  article?: string
  quantity?: string
  reasonForReturn?: string
  returnMessage?: string
  // options
  returnReasonOptions: string[]
  // styles
  formItemClass: string
  formLabelClass: string
  textFieldStyle: string
  textFieldStyleMultiline: string
}) {
  return (
    <>
      <div className="mt-4">
        <p className="mb-2 font-semibold">{props.returnLabel}</p>
      </div>

      {props.show("article_active") && (
        <FormField
          control={props.form.control}
          name="ReclamationForm_ReturnArticle"
          render={({ field }) => (
            <FormItem className={props.formItemClass}>
              <label className={props.formLabelClass}>
                {props.article ?? "Betroffener Artikel"}
                {props.reqRetArticle && <span className="ml-1 text-sm text-primary">*</span>}
              </label>
              <FormControl>
                <Input className={props.textFieldStyle} {...field} placeholder={props.article ?? "Betroffener Artikel"} />
              </FormControl>
              <FormMessage className="lg:col-start-2" />
            </FormItem>
          )}
        />
      )}

      {props.show("quantity_active") && (
        <FormField
          control={props.form.control}
          name="ReclamationForm_ReturnQuantity"
          render={({ field }) => (
            <FormItem className={props.formItemClass}>
              <label className={props.formLabelClass}>
                {props.quantity ?? "Menge"}
                {props.reqRetQuantity && <span className="ml-1 text-sm text-primary">*</span>}
              </label>
              <FormControl>
                <Input className={props.textFieldStyle} {...field} placeholder={props.quantity ?? "Menge"} />
              </FormControl>
              <FormMessage className="lg:col-start-2" />
            </FormItem>
          )}
        />
      )}

      {props.show("reason_for_return_active") && (
        <FormField
          control={props.form.control}
          name="ReclamationForm_ReturnReason"
          render={({ field }) => (
            <FormItem className={props.formItemClass}>
              <label className={props.formLabelClass}>
                {props.reasonForReturn ?? "Retourengrund"}
                {props.reqRetReason && <span className="ml-1 text-sm text-primary">*</span>}
              </label>
              <Select value={field.value} onValueChange={field.onChange}>
                <FormControl>
                  <SelectTrigger className={props.textFieldStyle}>
                    <SelectValue placeholder={props.t("common.filter_select")} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {props.returnReasonOptions.length > 0 ? (
                    props.returnReasonOptions.map((option) => (
                      <SelectItem key={option} value={option}>
                        {option}
                      </SelectItem>
                    ))
                  ) : (
                    <SelectItem value="" disabled>
                      {props.t("common.filter_select")}
                    </SelectItem>
                  )}
                </SelectContent>
                <input type="hidden" name={field.name} value={field.value ?? ""} />
              </Select>
              <FormMessage className="lg:col-start-2" />
            </FormItem>
          )}
        />
      )}

      {props.show("return_message_active") && (
        <FormField
          control={props.form.control}
          name="ReclamationForm_ReturnMessage"
          render={({ field }) => (
            <FormItem className={props.formItemClass}>
              <label className={props.formLabelClass}>
                {props.returnMessage ?? "Nachricht"}
                {props.reqRetMessage && <span className="ml-1 text-sm text-primary">*</span>}
              </label>
              <FormControl>
                <Textarea className={props.textFieldStyleMultiline + " h-32"} {...field} placeholder={props.returnMessage ?? "Nachricht"} />
              </FormControl>
              <FormMessage className="lg:col-start-2" />
            </FormItem>
          )}
        />
      )}
    </>
  )
}
